// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Input group for adding paths */
.ExcludePathsSettings_inputGroup__pXroz {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.ExcludePathsSettings_pathInput__qMmo9 {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.ExcludePathsSettings_pathInput__qMmo9:focus {
  outline: none;
  border-color: #d00135;
  box-shadow: 0 0 0 2px rgba(208, 1, 53, 0.1);
}
.ExcludePathsSettings_title__si00L {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
  text-align: center;
  padding-bottom: 24px;
  border-bottom: 2px solid #e9ecef;
}
.ExcludePathsSettings_updateBtn__qBZx7 {
  background-color: var(--saveBtn);
  color: var(--white-color);
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 24px;
  width: 100%;
  max-width: 200px;
}

.ExcludePathsSettings_updateBtn__qBZx7:hover:not(:disabled) {
  background-color: var(--saveHover);
}

.ExcludePathsSettings_updateBtn__qBZx7:disabled {
  background-color: var(--cancelBtn);
  cursor: not-allowed;
  opacity: 0.7;
  color: var(--heading);
}
.ExcludePathsSettings_addButton__s6f6z {
  padding: 8px 16px;
  background-color: #d00135;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.ExcludePathsSettings_addButton__s6f6z:hover:not(:disabled) {
  background-color: #b0012d;
}

.ExcludePathsSettings_addButton__s6f6z:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Paths list styling */
.ExcludePathsSettings_pathsList__v4-Pl {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 10px;
  min-height: 50px;
}

.ExcludePathsSettings_pathItem__eWJ9g {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: all 0.2s;
}

.ExcludePathsSettings_pathItem__eWJ9g:hover {
  border-color: #d00135;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ExcludePathsSettings_pathText__udUKm {
  font-family: monospace;
  font-size: 14px;
  color: #333;
}

.ExcludePathsSettings_removeButton__Cmejw {
  background: none;
  border: none;
  color: #999;
  font-size: 20px;
  cursor: pointer;
  padding: 0 5px;
  transition: color 0.2s;
}

.ExcludePathsSettings_removeButton__Cmejw:hover {
  color: #d00135;
}

.ExcludePathsSettings_noPathsMessage__uKaS4 {
  text-align: center;
  color: #999;
  font-style: italic;
  padding: 10px;
  margin: 0;
}

/* Toggle switch styling (if not already present) */
.ExcludePathsSettings_toggleSwitch__TvsRw {
  width: 50px;
  height: 24px;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ExcludePathsSettings_toggleOn__\\+lHrv {
  background-color: #d00135;
}

.ExcludePathsSettings_toggleOff__EeFAx {
  background-color: #ccc;
}

.ExcludePathsSettings_toggleSlider__FO0mL {
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  transition: left 0.2s;
}

.ExcludePathsSettings_toggleOn__\\+lHrv .ExcludePathsSettings_toggleSlider__FO0mL {
  left: 28px;
}

.ExcludePathsSettings_toggleOff__EeFAx .ExcludePathsSettings_toggleSlider__FO0mL {
  left: 2px;
}

.ExcludePathsSettings_toggleContainer__gEgEy {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ExcludePathsSettings_toggleLabel__TxQsS {
  min-width: 60px;
  font-size: 14px;
  color: #666;
}

.ExcludePathsSettings_controlGroup__s2xr2 {
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
}

.ExcludePathsSettings_controlLabel__3UFJo {
  display: block;
  width: 100%;
}

.ExcludePathsSettings_labelText__6TPng {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.ExcludePathsSettings_helperText__Fx0s6 {
  margin-top: 8px;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/GeneralAppSettings/ExcludePathsSettings.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* Input group for adding paths */\n.inputGroup {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n}\n\n.pathInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.pathInput:focus {\n  outline: none;\n  border-color: #d00135;\n  box-shadow: 0 0 0 2px rgba(208, 1, 53, 0.1);\n}\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n  text-align: center;\n  padding-bottom: 24px;\n  border-bottom: 2px solid #e9ecef;\n}\n.updateBtn {\n  background-color: var(--saveBtn);\n  color: var(--white-color);\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  margin-top: 24px;\n  width: 100%;\n  max-width: 200px;\n}\n\n.updateBtn:hover:not(:disabled) {\n  background-color: var(--saveHover);\n}\n\n.updateBtn:disabled {\n  background-color: var(--cancelBtn);\n  cursor: not-allowed;\n  opacity: 0.7;\n  color: var(--heading);\n}\n.addButton {\n  padding: 8px 16px;\n  background-color: #d00135;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.addButton:hover:not(:disabled) {\n  background-color: #b0012d;\n}\n\n.addButton:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Paths list styling */\n.pathsList {\n  background-color: #f9f9f9;\n  border-radius: 4px;\n  padding: 10px;\n  min-height: 50px;\n}\n\n.pathItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  margin-bottom: 8px;\n  transition: all 0.2s;\n}\n\n.pathItem:hover {\n  border-color: #d00135;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.pathText {\n  font-family: monospace;\n  font-size: 14px;\n  color: #333;\n}\n\n.removeButton {\n  background: none;\n  border: none;\n  color: #999;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0 5px;\n  transition: color 0.2s;\n}\n\n.removeButton:hover {\n  color: #d00135;\n}\n\n.noPathsMessage {\n  text-align: center;\n  color: #999;\n  font-style: italic;\n  padding: 10px;\n  margin: 0;\n}\n\n/* Toggle switch styling (if not already present) */\n.toggleSwitch {\n  width: 50px;\n  height: 24px;\n  border-radius: 12px;\n  position: relative;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.toggleOn {\n  background-color: #d00135;\n}\n\n.toggleOff {\n  background-color: #ccc;\n}\n\n.toggleSlider {\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  transition: left 0.2s;\n}\n\n.toggleOn .toggleSlider {\n  left: 28px;\n}\n\n.toggleOff .toggleSlider {\n  left: 2px;\n}\n\n.toggleContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.toggleLabel {\n  min-width: 60px;\n  font-size: 14px;\n  color: #666;\n}\n\n.controlGroup {\n  margin-bottom: 24px;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.controlLabel {\n  display: block;\n  width: 100%;\n}\n\n.labelText {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.helperText {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputGroup": `ExcludePathsSettings_inputGroup__pXroz`,
	"pathInput": `ExcludePathsSettings_pathInput__qMmo9`,
	"title": `ExcludePathsSettings_title__si00L`,
	"updateBtn": `ExcludePathsSettings_updateBtn__qBZx7`,
	"addButton": `ExcludePathsSettings_addButton__s6f6z`,
	"pathsList": `ExcludePathsSettings_pathsList__v4-Pl`,
	"pathItem": `ExcludePathsSettings_pathItem__eWJ9g`,
	"pathText": `ExcludePathsSettings_pathText__udUKm`,
	"removeButton": `ExcludePathsSettings_removeButton__Cmejw`,
	"noPathsMessage": `ExcludePathsSettings_noPathsMessage__uKaS4`,
	"toggleSwitch": `ExcludePathsSettings_toggleSwitch__TvsRw`,
	"toggleOn": `ExcludePathsSettings_toggleOn__+lHrv`,
	"toggleOff": `ExcludePathsSettings_toggleOff__EeFAx`,
	"toggleSlider": `ExcludePathsSettings_toggleSlider__FO0mL`,
	"toggleContainer": `ExcludePathsSettings_toggleContainer__gEgEy`,
	"toggleLabel": `ExcludePathsSettings_toggleLabel__TxQsS`,
	"controlGroup": `ExcludePathsSettings_controlGroup__s2xr2`,
	"controlLabel": `ExcludePathsSettings_controlLabel__3UFJo`,
	"labelText": `ExcludePathsSettings_labelText__6TPng`,
	"helperText": `ExcludePathsSettings_helperText__Fx0s6`
};
export default ___CSS_LOADER_EXPORT___;
